module.exports = __webpack_public_path__ + "img/img16.4b28ecbc.svg";